import React, { Fragment, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Unstable_Grid2";
import Typography from "@mui/material/Typography";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import SystemUpdateAltIcon from "@mui/icons-material/SystemUpdateAlt";
import IconButton from "@mui/material/IconButton";
import PolicyContext from "../../../context/policy/PolicyContext";
import RichTextBoxEditer from "../../../components/RichTextBoxEditer";
import DialogBoxComponent from "../../../components/DialogBoxComponent";
import { Tooltip } from "@mui/material";
import {
  EditPlan,
  PlanImport,
  DeletePlan,
} from "../../../assets/RiskManagementIcon";
import {
  deletePolicy,
  downloadPolicy,
  editPolicy,
  fetchPolicyById,
} from "../helper";
import { useUserContext } from "../../../context/auth/UserContext";
import { AccessRight } from "../../../modal/UserAccess";
import { getUserName } from "../../../helper/helper";

export const DisplayPolicy = (props: {
  refreshList: () => void;
  policyPageAccess: AccessRight | null;
}) => {
  const { policyPageAccess } = props;

  const navigate = useNavigate();
  const [policyDetails, setPolicyDetails] = useState<any>({});
  const [dialogState, setDialogState] = useState({
    title: "",
    body: "",
    action: "",
    actionCancel: "",
    openDeleteConfirmationDialog: false,
    openSuccessDialogBox: false,
  });
  const { userId, companyProfileID } = useUserContext();
  const policyContext = useContext(PolicyContext);
  const { previewPolicy, setPreviewPolicyRecord } = policyContext;

  const displayEditPolicy = async (details: any) => {
    const date = new Date();
    const payload = {
      ...details,
      isEditedByUser: true,
      isEditedByUserId: userId + "",
      updateBy: userId,
      updateDate: date,
    };

    const resUpdate = await editPolicy(payload);
    if (resUpdate.succeeded === true) {
      navigate("/add-policy");
    }
  };

  const handleDownloadPolicy = () => {
    const res = downloadPolicy(policyDetails, companyProfileID);
    // console.log("handleDeletePolicy res", payload, res);
  };

  const handleCloseDialog = () => {
    if (dialogState.title === "Success") {
      props.refreshList();
      setDialogState({
        ...dialogState,
        openDeleteConfirmationDialog: false,
        openSuccessDialogBox: false,
      });
    } else {
      setDialogState({
        ...dialogState,
        openDeleteConfirmationDialog: false,
        openSuccessDialogBox: false,
      });
    }
  };

  const handleEditPolicy = async () => {
    const res = await fetchPolicyById(policyDetails.policyID);
    // console.log("handleEditPolicy plan", res, policyDetails);
    if (res.isEditedByUser && parseInt(res.isEditedByUserId) !== userId) {
      let userName = await getUserName(res.isEditedByUserId);
      setDialogState({
        title: "Info",
        body: `You are unable to modify this policy because ${userName} has already begun editing it.`,
        action: "Ok",
        actionCancel: "",
        openDeleteConfirmationDialog: false,
        openSuccessDialogBox: true,
      });
    } else {
      displayEditPolicy(res);
    }
  };

  const handleDeletePolicy = async () => {
    setPreviewPolicyRecord && setPreviewPolicyRecord({});
    setDialogState(() => ({
      ...dialogState,
      openDeleteConfirmationDialog: false,
      openSuccessDialogBox: false,
    }));

    const date = new Date();
    const payload = {
      policyID: [policyDetails.policyID],
      isDeleted: true,
      updateBy: userId,
      updateDate: date,
    };
    const res = await deletePolicy(payload);
    // console.log("handleDeletePolicy res", payload, res);
    if (res.succeeded === true) {
      setDialogState({
        title: "Success",
        body: "Policy successfully deleted",
        action: "OK",
        actionCancel: "",
        openDeleteConfirmationDialog: false,
        openSuccessDialogBox: true,
      });
    } else {
      setDialogState({
        title: "Error",
        body: "Unexpected Error",
        action: "OK",
        actionCancel: "",
        openDeleteConfirmationDialog: false,
        openSuccessDialogBox: true,
      });
    }
  };

  const confirmDelete = () => {
    setDialogState({
      title: "Confirmation",
      body: `Are you sure you want to delete <strong>${policyDetails.policyName}</strong>?`,
      action: "Delete",
      actionCancel: "Cancel",
      openDeleteConfirmationDialog: true,
      openSuccessDialogBox: false,
    });
  };

  useEffect(() => {
    if (previewPolicy && Object.keys(previewPolicy).length > 0) {
      setPolicyDetails(previewPolicy);
    } else {
      setPolicyDetails({});
    }
  }, [previewPolicy]);
  console.log("policyPageAccess", policyPageAccess);

  return (
    <Fragment>
      <Grid sx={{ height: "100%", width: "100%" }}>
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid xs={8}>
            <h3 style={{ fontWeight: "400" }}> {policyDetails.policyName}</h3>
          </Grid>
          <Grid>
            <Tooltip title="Download Policy">
              <IconButton
                aria-label="download"
                disabled={!policyPageAccess?.isDownload}
                onClick={handleDownloadPolicy}
              >
                {React.createElement(PlanImport, {
                  opacity: !policyPageAccess?.isDownload ? "50%" : "100%",
                })}
              </IconButton>
            </Tooltip>
            <Tooltip title="Edit Policy">
              <IconButton
                aria-label="edit"
                disabled={!policyPageAccess?.isUpdate}
                onClick={handleEditPolicy}
              >
                {React.createElement(EditPlan, {
                  opacity: !policyPageAccess?.isUpdate ? "50%" : "100%",
                })}
              </IconButton>
            </Tooltip>
            <Tooltip title="Delete Policy">
              <IconButton
                aria-label="delete"
                disabled={!policyPageAccess?.isDelete}
                onClick={confirmDelete}
              >
                {React.createElement(DeletePlan, {
                  opacity: !policyPageAccess?.isDelete ? "50%" : "100%",
                })}
              </IconButton>
            </Tooltip>
          </Grid>
        </Grid>
        <Grid>
          <h5
            style={{
              margin: "0.5rem 0",
              color: "#292D32",
              opacity: "40%",
              fontStyle: "italic",
            }}
          >
            Policy Overview
          </h5>
          <h5
            style={{
              margin: "0.5rem 0",
              fontWeight: "400",
            }}
          >
            <RichTextBoxEditer
              readOnly={true}
              editorContent={
                policyDetails.policyContent ? policyDetails.policyContent : ""
              }
              onChange={() => {}}
            />
          </h5>
        </Grid>
      </Grid>
      {
        <DialogBoxComponent
          openDialogBox={dialogState.openSuccessDialogBox}
          dialogTitle={dialogState.title}
          dialogAction={dialogState.action}
          dialogBody={dialogState.body}
          handleFunction={handleCloseDialog}
        />
      }
      {
        <DialogBoxComponent
          openDialogBox={dialogState.openDeleteConfirmationDialog}
          dialogTitle={dialogState.title}
          dialogAction={dialogState.action}
          dialogActionCancel={dialogState.actionCancel}
          dialogBody={dialogState.body}
          handleFunction={handleDeletePolicy}
          handleCancel={handleCloseDialog}
        />
      }
    </Fragment>
  );
};
